/* eslint-disable no-console */
/* eslint-disable no-console */
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(registrations => {
    for (const registration of registrations) {
      registration.unregister();
      console.log('SW odstranjen');
    }
  });
}


/*
import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js?v=2`, {
    ready () {
      console.log('App is being served from cache.')
    },
    registered (registration) {
      console.log('Service worker has been registered.')
      
      // DODATEK: Vsakič ko uporabnik odpre stran, ročno preveri za posodobitve
      // To prepreči, da bi uporabnik ostal na stari verziji več dni.
      setInterval(() => {
        registration.update();
      }, 1000 * 60 * 60); // Preveri vsako uro
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound() {
      console.log('New content is downloading.')
    },
    updated(registration) {
      console.log('New content is available; updating now.');
      if (registration && registration.waiting) {
        // Pošljemo ukaz za aktivacijo novega SW
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
    },
    offline () {
      console.log('No internet connection found.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })

  // Poslušaj na aktivacijo novega SW in osveži stran
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    window.location.reload();
  });
}
*/
